import React from 'react';

export const StepSuccess: React.FC = () => {
  return (
    <div className="animate-fade-in text-center py-15">
      <div className="w-16 h-16 border-2 border-primary rounded-full flex items-center justify-center mx-auto mb-8">
        <span className="text-[32px]">✓</span>
      </div>
      <h2 className="text-2xl font-light mb-4">Demande envoyée</h2>
      <p className="text-sm text-secondary">
        Vous recevrez votre estimation par email
        <br />
        dans les prochaines minutes.
      </p>
      <p className="mt-4 font-semibold">
        Pensez à vérifier vos spams si vous ne recevez rien.
      </p>
    </div>
  );
};
